import type { Idioma } from '../../../i18n/index.js';
import type { Seccion } from '../comoFunciona.js';

/**
 * Una página de texto: título y secciones. La usan quién está detrás, privacidad y aviso legal.
 *
 * Es una sola y no tres porque las tres son lo mismo: texto que se lee. Tres componentes casi
 * iguales se separan solos con el tiempo y acaban con tres tipografías distintas.
 */
export function TextoPage({ titulo, secciones }: { readonly titulo: string; readonly secciones: readonly Seccion[]; readonly idioma?: Idioma }) {
  return (
    <div className='flex grow flex-col'>
      <main className='mx-auto flex w-full max-w-[720px] grow flex-col gap-9 px-6 py-12'>
        <h1 className='m-0 font-(family-name:--serif) text-[36px] leading-tight font-bold'>{titulo}</h1>
        {secciones.map(seccion => (
          <section key={seccion.titulo}>
            <h2 className='m-0 mb-3 font-(family-name:--serif) text-[21px] font-bold'>{seccion.titulo}</h2>
            {seccion.parrafos.map(p => (
              <p key={p.slice(0, 30)} className='mt-0 mb-4 font-(family-name:--text) text-[16px] leading-[1.65] text-(--ink)'>
                {p}
              </p>
            ))}
          </section>
        ))}
      </main>
    </div>
  );
}
